<template>
    <div id='Main'>

        <div class="main1">
            <div class="play_time">{{ rest_time_txt }}</div>
            <!-- <div class="play_btn"></div> -->
        </div>
        <div class="main2">
            <div class="award_items">

                <div class="award item2">
                    <div class="num">1</div>
                </div>
            </div>

        </div>

        <div class="main4">
            <div class="list">
                <PlayItem v-for="(item, k) in play_list" :key="k" :item="item" class="playitem"></PlayItem>
            </div>
        </div>
        <div class="main6">
            <div class="video_area">
                <div class="play_btn play_img" @click="play_video()"></div>
            </div>

        </div>

        <div class="main3">
            <div class="con">
                <div class="con_tobind" v-if="tobind">
                    <div class="con_bind"></div>
                    <div class="con_qrcode" @click="jump_to()"></div>
                </div>
                <div class="con_def" v-else></div>
            </div>
        </div>

        <div class="main5">
            <div class="rule_txt"></div>

        </div>

    </div>
</template>

<script>
import vue from "vue";
import PlayItem from "./sub/PlayItem.vue";
export default vue.component('Main', {
    components: {
        PlayItem
    },
    props: {
        chn: String,
    },
    data() {
        return {
            rest_time: 0,
            play_list: [],
            bind: 0,
            chn: '',
        }
    },
    created() {
        let image = new Image()
        image.src = ""

    },
    mounted() {
        var gap = 10

        var s = setInterval(() => {
            this.rest_time -= gap
            if (this.rest_time <= 0) {
                clearInterval(s)
            }
        }, gap * 1000)

    },
    methods: {
        init(obj) {
            this.$set(this, 'rest_time', obj.rest_time)
            this.$set(this, 'play_list', this.$game_config.get_play_list(obj.play_list))
            this.$set(this, 'bind', obj.bind)
        },
        play_video() {

            console.log('play_video')
            var msg = {
                show_type: 'video',
                src: 'http://download01-official-whhx.ehijoy.com/2025.07.15/DaTangMarketingPV.mp4'
            }
            this.$eventBus.$emit('show_dialog', msg)
            return
        },
        jump_to() {
            // 需要短链
            window.location.href = this.$game_config.wx_url
        }
    },
    computed: {
        rest_time_txt() {
            var t = this.$game_config.get_rest_time_txt(this.rest_time)
            return t
        },
        proc_txt() {
            var arr = this.play_list.filter(i => i.pass)
            var all = this.play_list.length
            var len = arr.length
            return `${len}/${all}`
        },
        tobind() {
            //  - 官方渠道：渠道ID为2、3时展示提及企业微信的对话
            if (this.$game_config.gfb_chn(this.chn) && !this.bind) { return true }
            return false
        },


    }

})
</script>

<style scoped>
#Main {
    position: relative;
    width: 1080px;
    height: 5520px;
    /* display: flex;
    justify-content: center;
    align-items: center; */
    flex-direction: column;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guest/bg.png') no-repeat center;
    background-size: 100% auto;
    font-family: 'xique';
}

/*内容区域 从上到下 */

.main1 {
    /* border: 1px solid red; */
    position: relative;
    width: 100%;
    height: 990px;
}

.main1 .play_time {
    /* border: 1px solid red; */
    width: 176px;
    height: 64px;
    position: absolute;
    top: 222px;
    right: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    color: #fcedb6;
}

.main2 {
    /* border: 1px solid red; */
    position: relative;
    width: 100%;
    height: 450px;
}

.main2 .award_items {
    /* border: 1px solid red; */
    position: absolute;
    left: 180px;
    top: 169px;
    display: flex;
    justify-content: space-around;
    width: 290px;
    height: 120px;
}

.award_items .award {
    width: 150px;
    height: 150px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/award/award_bg.png') no-repeat center;
    background-size: 100% auto;
    display: flex;
    flex-flow: column;
    align-items: center;
}

.award .num {
    font-size: 50px;
    color: white;
    margin-top: 112px;
    -webkit-text-stroke: 1px black;
    text-stroke: 1px black;
    text-shadow:
        -1px -1px 0 black,
        1px -1px 0 black,
        -1px 1px 0 black,
        1px 1px 0 black;
}

.award_items .item1 {
    background-image: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/award/item1.jpg')
}

.award_items .item2 {
    background-image: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/award/item2.jpg')
}

.main2 .award_txt {
    /* border: 1px solid red; */
    position: absolute;
    left: 550px;
    top: 173px;
    width: 349px;
    height: 94px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/award/award_txt.png') no-repeat center;
    background-size: 100% auto;
}

.main2 .award_proc {
    /* border: 1px solid red; */
    position: absolute;
    left: 904px;
    top: 230px;
    width: 80px;
    height: 40px;
    font-size: 40px;
    color: #a42423;
}

.main3 {
    position: relative;
    width: 100%;
    height: 547px;

}

.main3 .con {
    /* border: 1px solid red; */
    position: absolute;
    top: 64px;
    width: 100%;
    height: 340px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.main3 .con_tobind {
    width: 900px;
    height: 250px;
    display: flex;
}

.con_tobind .con_bind {
    width: 634px;
    height: 228px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/qrcode/con_bind.png') no-repeat center;
    background-size: 100% auto;
}

.con_tobind .con_qrcode {
    width: 219px;
    height: 230px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/qrcode/con_qrcode.png') no-repeat center;
    background-size: 100% auto;
}

.main3 .con_def {
    width: 710px;
    height: 221px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/qrcode/con_def.png') no-repeat center;
    background-size: 100% auto;

}

.main4 {
    position: relative;
    width: 100%;
    height: 1570px;

}

.main4 .list {
    /* border: 1px solid red; */
    position: absolute;
    top: 100px;
    left: 56px;
    width: 967px;
    height: 1449px;
    padding-top: 25px;
    display: flex;
    flex-flow: row wrap;
    /* 交叉多行时，内容的布局方式 */
    align-content: flex-start;
}

.main4 .playitem {
    margin: 30px 23px;
}

.main5 {
    /* border: 1px solid red; */
    position: relative;
    width: 100%;
    height: 1100px;
}

.main5 .rule_txt {
    position: absolute;
    width: 875px;
    height: 705px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/rule_txt.png') no-repeat center;
    background-size: 100% auto;
    top: 217px;
    left: 107px;
}


.main6 {
    /* border: 1px solid red; */
    position: relative;
    width: 100%;
    height: 832px;
    display: flex;
    flex-flow: column;
    align-items: center;
}

.play_img {
    width: 141px;
    height: 135px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/play.png') no-repeat center;
    background-size: 100% auto;
}

.main6 .play_btn {}

.main6 .video_area {
    position: relative;
    /* border: 1px solid red; */
    margin-top: 203px;
    width: 930px;
    height: 578px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guest/video_bg.jpg') no-repeat center;
    background-size: 100% auto;

}
</style>